export default __webpack_public_path__ + "static/media/dgl-with-boy.d0e89bc1.jpg";